import { push } from 'react-router-redux';
import Cookies from 'js-cookie';

import forceLogoutHandler from '../users/a.users.forceLogoutHandler';

import {

} from '../actions.export'

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// Delete a file
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestDeleteFile = packet => {
  return {
    type: 'REQUEST_DELETE_FILE',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveDeleteFileSuccess = data => ({
  type: 'RECEIVE_DELETE_FILE_SUCCESS',
  data
})

export const receiveDeleteFileFail = data => ({
  type: 'RECEIVE_DELETE_FILE_FAIL',
  data
})

export const tryToDeleteFile = packet => (dispatch, getState) => {

  dispatch(requestDeleteFile(packet));

  let headers = {
    "Content-Type": "application/json"
  }
  


  let fs = localStorage.getItem(process.env.REACT_APP_COOKIE_FEATURE_SWITCH);
  if(fs){
    headers["X-NFS"] = fs;
  }


  headers["X-CSRF-TOKEN"] = getState().userReducer.csrf_token;
  return fetch('/api/knowledge/' + packet.knowledge_id + '/files/' + packet.id, {
      method: 'delete',
      body: JSON.stringify(packet),
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(receiveDeleteFileSuccess(json));
    })
    .catch(e => {
      dispatch(forceLogoutHandler(e));
      dispatch(receiveDeleteFileFail({errors:e, lastSubmit: packet}));
    })
}
